import { render, staticRenderFns } from "./CustomerLeadsTable.vue?vue&type=template&id=6a3b049d&scoped=true&"
import script from "./CustomerLeadsTable.vue?vue&type=script&lang=js&"
export * from "./CustomerLeadsTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomerLeadsTable.vue?vue&type=style&index=0&id=6a3b049d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3b049d",
  null
  
)

export default component.exports